export const COLORS = {
  low: '#767C51',
  medium: '#C19445',
  high: '#A6001E',
};
